const React = require('react');
const classnames = require('classnames');
const { string, node, bool } = require('prop-types');
const Arrow = require('./icons/Arrow');
const { track } = require('../helpers');

const namespace = 'layout';

const handleBackArrowClick = () => {
  window.parent.postMessage({ type: 'nav:cp:close' }, '*');
  track('navigation', 'close');
};

const Layout = ({
  title,
  children,
  deviceType,
  backUrl,
  isEmbed,
  isFlow,
  subtitle = '',
  webView,
  fullScreen,
  isScroll = false,
  hasAddresses = false,
  closeButtonSrLabel = '',
}) => {
  const classes = classnames('andes-modal', namespace, {
    'andes-modal--full': deviceType === 'mobile',
    [`${namespace}--default`]: !isEmbed,
    [`${namespace}--embed`]: isEmbed,
    [`${namespace}--flow`]: isFlow,
    [`${namespace}--webView`]: webView,
    [`${namespace}--full-screen`]: fullScreen,
  });
  const classesHeader = classnames('andes-modal-dialog__header', {
    [`${namespace}--embed__header`]: isEmbed,
    [`${namespace}--webView__header`]: webView,
  });
  const classesContent = classnames('andes-modal-dialog__content', {
    [`${namespace}--embed__content`]: isEmbed,
    'andes-modal-dialog__content--scrolled': isScroll,
  });

  return (
    <div className={classes}>
      <div className={classesHeader}>
        <h1 className={`${namespace}__header-title andes-modal-dialog__header-title`}>{title}</h1>
        {deviceType === 'mobile' && !webView && !isFlow && (
          <a
            href={backUrl}
            className="andes-modal-dialog__button-close layout-arrow"
            onClick={handleBackArrowClick}
            data-testid="back-arrow"
            aria-label="back-arrow"
          >
            <Arrow />
          </a>
        )}
        {isEmbed && !hasAddresses && !isFlow && (
          <button
            data-js="modal-iframe-close"
            className="andes-modal-dialog__button-close"
            aria-label={closeButtonSrLabel}
          />
        )}
      </div>
      <div className={classesContent}>
        <p className={`${namespace}__header-subtitle`}>{subtitle}</p>
        {children}
      </div>
    </div>
  );
};

Layout.propTypes = {
  title: string.isRequired,
  children: node.isRequired,
  deviceType: string.isRequired,
  backUrl: string.isRequired,
  isEmbed: bool.isRequired,
  isFlow: bool.isRequired,
  subtitle: string,
  webView: bool.isRequired,
  fullScreen: bool.isRequired,
  isScroll: bool,
  hasAddresses: bool,
  closeButtonSrLabel: string.isRequired,
};

module.exports = Layout;
